<p-toast key="tst_login"></p-toast>

<!-- Container principal da tela de login -->
<div class="login-container">

  <!-- Imagem de fundo da página -->
  <img src="assets/images/login/highway.jpg"
       alt="Background"
       class="background-image">

  <!-- Container do formulário de login -->
  <div class="login-form-container">

    <!-- Logo principal do login -->
    <img src="assets/images/falcon_logo/Velsis_Produto_FalconVS_azul_previa.png"
         alt="Falcon logo"
         class="login-logo">

    <div class="w-full text-center label-line">
      <span style="background-color: rgb(236 234 244);" class="text-base font-semibold">Acesse Sua Conta</span>
    </div>

    <!-- Campo de input para o email -->
    <span class="p-float-label">
      <input pInputText
             id="email"
             [disabled]="isLoading"
             [(ngModel)]="model.email"
             [ngStyle]="{'width': '100%'}"
             (keydown.enter)="senhaInput.focus()"/>
      <label htmlFor="email" style="background-color: rgb(236 234 244);">Email</label>
    </span>

    <!-- Campo de input para a senha -->
    <span class="p-float-label mt-4">
      <input pInputText
             id="senha"
             #senhaInput
             [disabled]="isLoading"
             type="password"
             [(ngModel)]="model.password"
             [ngStyle]="{'width': '100%'}"
             (keydown.enter)="login()"/>
      <label htmlFor="senha" style="background-color: rgb(236 234 244);">Senha</label>
    </span>


    <!-- Botão para enviar o formulário de login -->
    <div class="flex justify-content-center mt-4">
      <p-button [label]="isLoading ? loader.msgLoader ?? 'Entrando' : 'Entrar'"
                (onClick)="login()"
                icon="pi {{isLoading ? 'pi-spin pi-spinner' : 'pi-check'}}"
                size="large"
                [ngClass]="{
                  'opacity-50': isLoading,
                }"
                [style]="{'background-color': '#043681'}">
      </p-button>
    </div>

    <p-button label="Esqueci a senha" [style]="{'color': '#043681'}"
              [link]="true" (click)="show()"
              [ngClass]="{
                'opacity-50': isLoading,
              }"
              styleClass="text-x"></p-button>
  </div>
  <img src="assets/images/login/logo-velsis.png"
       alt="Velsis logo" style="margin-bottom: 1rem;"
       class="absolute velsis-logo w-1 bottom-0">
</div>
